import { Component, OnInit, inject } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SharedService } from '../../api/services/shared.service';
import { ButtonModule } from 'primeng/button';
import { FormGroup, ReactiveFormsModule, FormBuilder } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Select } from 'primeng/select';
import {
  BolsaService,
  EnumService,
  SolicitacaoRenovacaoService,
  BolsaInstituicaoCursoService,
  MatriculaService,
} from '../../api/services';
import { InputText } from 'primeng/inputtext';
import { DatePicker } from 'primeng/datepicker';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { forkJoin } from 'rxjs';
import { Toast } from 'primeng/toast';
import { MessageService, ConfirmationService } from 'primeng/api';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { MatriculaListItemDTO } from '../../api/models/matriculaListItemDTO';
import { EnumEstadoMatricula } from '../../api/models/enumEstadoMatricula';
import { TagModule } from 'primeng/tag';
import { toDate, diffDays, diffMonthsAndDays } from '@app/shared/utils';
interface DocView {
  id: number;
  file: string;
  nome: string;
  extensao: string;
  mimeType: string;
  tamanhoBytes: number;
  tamanho: string;
}

@Component({
  selector: 'app-processo-renovacao',
  imports: [
    ButtonModule,
    ReactiveFormsModule,
    Select,
    CommonModule,
    InputText,
    DatePicker,
    BackButtonComponent,
    Toast,
    ConfirmDialog,
    TagModule,
  ],
  providers: [
    BolsaInstituicaoCursoService,
    BolsaService,
    EnumService,
    SolicitacaoRenovacaoService,
    MessageService,
    ConfirmationService,
  ],
  templateUrl: './processo-renovacao.component.html',
  styleUrl: './processo-renovacao.component.scss',
})
export class ProcessoRenovacaoComponent implements OnInit {
  route = inject(ActivatedRoute);
  router = inject(Router);
  sharedService = inject(SharedService);
  bolsaInstituicaoCursoService = inject(BolsaInstituicaoCursoService);
  bolsaService = inject(BolsaService);
  enumService = inject(EnumService);
  solicitacaoRenovacaoService = inject(SolicitacaoRenovacaoService);
  messageService = inject(MessageService);
  confirmactionService = inject(ConfirmationService);
  matriculaService = inject(MatriculaService);
  bolsaInstCursoRenovar: any;
  matricula: any | undefined;
  solicitacao: any;
  bolsaInstituicaoID: string = '';
  formRenovacao!: FormGroup;
  solicitacaoID: string | null = null;
  parecerOptions: any[] = [];
  parecerMirempetOptions: any[] = [
    { id: 1, label: 'Aprovado' },
    { id: 2, label: 'Reprovado' },
  ];
  docs: DocView[] = [];
  fb = inject(FormBuilder);

  mirempetParecer: number = 0;
  representanteParecer: number = 0;

  Return() {
    this.router.navigate(['/gestao-bolseiros/renovacao']);
  }

  ngOnInit() {
    this.solicitacaoID = this.route.snapshot.paramMap.get('id')!;
    if (this.solicitacaoID) {
      this.getSolicitacaoById(this.solicitacaoID);
    }

    this.formRenovacao = this.fb.group({
      NumeroBI: [{ value: '', disabled: true }],
      nome: [{ value: '', disabled: true }],
      InstituicaoID: [{ value: '', disabled: true }],
      instituicaoEnsinoNome: [{ value: '', disabled: true }],
      CursoID: [{ value: '', disabled: true }],
      cursoDesignacao: [{ value: '', disabled: true }],
      DataInicio: [{ value: '', disabled: true }],
      DataFim: [{ value: '', disabled: true }],
      duracao: [{ value: '', disabled: true }],
      estadoBolsaID: [{ value: '', disabled: true }],
      estadoDesc: [{ value: '', disabled: true }],
      anoCurricular: [{ value: '', disabled: true }],
      estadoSolicitacao: [{ value: '', disabled: true }],
      AnoLetivoAnterior: [{ value: '', disabled: true }],
      AnoLetivoAtivacao: [{ value: '', disabled: true }],
      parecerEstudante: [{ value: '', disabled: true }],
      parecerInstituicao: [{ value: '', disabled: true }],
      parecerMIREMPET: [null],
    });

    this.loadDropdowns();
    this.formRenovacao
      .get('parecerMIREMPET')
      ?.valueChanges.subscribe((value) => {
        this.mirempetParecer = value;
      });
  }

  getSolicitacaoById(id: any) {
    this.solicitacaoRenovacaoService.show(id).subscribe({
      next: (result: any) => {
        this.solicitacao = result;

        this.docs = this.mapDocs(this.solicitacao?.anexoRenovacaoBolsas);
        this.bolsaInstituicaoID = this.solicitacao?.bolsaID;

        this.formRenovacao.patchValue(
          {
            AnoLetivoAnterior: this.solicitacao?.anoLetivoAnterior?.ano ?? '',
            AnoLetivoAtivacao: this.solicitacao?.anoLetivoAtivacao?.ano ?? '',
            parecerEstudante: this.solicitacao?.parecerEstudante ?? null,
            parecerInstituicao: this.solicitacao?.parecerInstituicao ?? null,
            parecerMIREMPET: this.solicitacao?.parecerMIREMPET ?? null,
            NumeroBI: this.solicitacao?.bolsa?.bolseiro?.numeroBI ?? '',
            nome: this.solicitacao?.bolsa?.bolseiro?.nome ?? '',
            estadoBolsaID: this.solicitacao?.bolsa?.estadoBolsa ?? null,
            estadoDesc: this.getEstadoSolicitacao(this.solicitacao?.estado),
          },
          { emitEvent: false },
        );

        const bic = this.solicitacao?.matricula?.bolsaInstituicaoCurso;
        const iec = bic?.instituicaoEnsinoCurso;
        const instNome = iec?.instituicaoEnsino?.nome;
        const uoNome = iec?.unidadeOrganica?.nome;
        const curso = iec?.curso;

        // Datas top-level
        const di = toDate(bic?.dataInicio);
        const df = toDate(bic?.dataFim);
        console.log(di, df);
        let duracaoDias: number | null = null;
        let duracaoMeses: number | null = null;
        let duracaoMesesDiasLabel = '';

        if (di && df) {
          duracaoDias = diffDays(di, df);
          const md = diffMonthsAndDays(di, df);
          duracaoMeses = md.months;
          duracaoMesesDiasLabel =
            md.days > 0
              ? `${md.months} mês(es) e ${md.days} dia(s)`
              : `${md.months} mês(es)`;
        }

        this.formRenovacao.patchValue(
          {
            InstituicaoID: iec?.id ?? bic?.instituicaoEnsinoCursoID ?? null,
            instituicaoEnsinoNome:
              instNome && uoNome ? `${instNome} - ${uoNome}` : (instNome ?? ''),
            CursoID: curso?.id ?? iec?.cursoID ?? null,
            cursoDesignacao: curso?.designacao ?? '',
            DataInicio: di ?? toDate(bic?.dataInicio) ?? null,
            DataFim: df ?? toDate(bic?.dataFim) ?? null,
            duracao: duracaoMesesDiasLabel || null,
            duracaoDias,
            duracaoMeses,
            anoCurricular: this.getLabelAnoCurricular(
              Number(this.solicitacao?.matricula?.anoCurricular ?? 0),
            ),
          },
          { emitEvent: true },
        );

        if (
          this.solicitacao?.parecerMIREMPET === 1 ||
          this.solicitacao?.parecerMIREMPET === 2
        ) {
          this.formRenovacao.get('parecerMIREMPET')?.disable();
        } else {
          this.formRenovacao.get('parecerMIREMPET')?.enable();
        }

        this.representanteParecer = this.solicitacao?.parecerInstituicao;
        this.mirempetParecer = this.solicitacao?.parecerMIREMPET;
      },
      error: (error) => {
        console.error('Erro ao carregar a solicitação', error);
      },
    });
  }

  // getSolicitacaoById(id: string) {
  //   this.solicitacaoRenovacaoService.show(id).subscribe({
  //     next: (result: any) => {
  //       this.solicitacao = result;
  //       this.docs = this.mapDocs(this.solicitacao.anexoRenovacaoBolsas);
  //       this.bolsaInstituicaoID = this.solicitacao?.bolsaID;
  //       this.getBolsaInstituicaoCurso();
  //       this.getBolsaDetails(this.solicitacao?.bolsa?.id);
  //       this.formRenovacao.patchValue({
  //         parecerInstituicao: this.solicitacao?.parecerInstituicao,
  //         AnoLetivoAnterior: this.solicitacao?.anoLetivoAnterior?.ano,
  //         AnoLetivoAtivacao: this.solicitacao?.anoLetivoAtivacao?.ano,
  //         estadoSolicitacao: this.getEstadoSolicitacao(
  //           this.solicitacao?.estado
  //         ),
  //         parecerMIREMPET: this.solicitacao.parecerMIREMPET,
  //       });
  //       if (this.solicitacao?.parecerMIREMPET != 3) {
  //         this.formRenovacao.get('parecerMIREMPET')?.disable();
  //       }

  //       this.representanteParecer = this.solicitacao?.parecerInstituicao;
  //       this.mirempetParecer = this.solicitacao?.parecerMIREMPET;
  //     },
  //     error: (error) => {
  //       console.error('Erro ao carregar da bolsa', error);
  //     },
  //   });
  // }

  private mapDocs(list: any[] | undefined): DocView[] {
    if (!Array.isArray(list)) return [];
    return list
      .map((item) => item?.anexo)
      .filter(Boolean)
      .map((a: any) => {
        const bytes = this.base64SizeInBytes(a?.file);
        return {
          id: a?.id ?? 0,
          file: a?.file ?? '',
          nome: a?.descricao ?? 'Documento',
          extensao: a?.extensao ?? '',
          mimeType: a?.mimeType ?? '',
          tamanhoBytes: bytes,
          tamanho: this.formatBytes(bytes),
        } as DocView;
      });
  }

  private base64SizeInBytes(b64?: string): number {
    if (!b64) return 0;
    const cleaned = b64.replace(/[^A-Za-z0-9+/=]/g, '');
    const padding = cleaned.endsWith('==') ? 2 : cleaned.endsWith('=') ? 1 : 0;
    return Math.floor((cleaned.length * 3) / 4) - padding;
  }

  private formatBytes(bytes: number, decimals = 2): string {
    if (!bytes) return '0 Bytes';
    const k = 1024;
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(decimals))} ${
      sizes[i]
    }`;
  }

  getBolsaInstituicaoCurso() {
    const params = {
      BolsaID: this.bolsaInstituicaoID,
    };

    this.bolsaInstituicaoCursoService.list(params).subscribe(
      (result: any) => {
        this.bolsaInstCursoRenovar = result.data[0];
        this.getMatricula(this.bolsaInstCursoRenovar?.id);

        const dataInicio = this.parseDateBr(
          this.bolsaInstCursoRenovar?.dataInicio,
        );
        const dataFim = this.parseDateBr(this.bolsaInstCursoRenovar?.dataFim);

        let duracaoAnos = null;
        if (dataInicio && dataFim) {
          const diffMs = dataFim.getTime() - dataInicio.getTime();
          const diffAnos = diffMs / (1000 * 60 * 60 * 24 * 365);
          duracaoAnos = Math.floor(diffAnos);
        }

        this.formRenovacao.patchValue({
          InstituicaoID: this.bolsaInstCursoRenovar?.instituicaoEnsinoCursoID,
          instituicaoEnsinoNome:
            this.bolsaInstCursoRenovar?.instituicaoEnsinoCursoNome,
          CursoID: this.bolsaInstCursoRenovar?.cursoID,
          cursoDesignacao: this.bolsaInstCursoRenovar?.cursoDesignacao,
          DataInicio: this.bolsaInstCursoRenovar?.dataInicio,
          DataFim: this.bolsaInstCursoRenovar?.dataFim,
          duracao: duracaoAnos,
        });
      },
      (error) => {
        console.error('Erro ao carregar Bolsa Instituição Curso', error);
      },
    );
  }

  parseDateBr(dateStr: string): Date | null {
    if (!dateStr) return null;
    const parts = dateStr.split('/'); // dd/MM/yyyy
    if (parts.length === 3) {
      const dia = parseInt(parts[0], 10);
      const mes = parseInt(parts[1], 10) - 1; // meses começam em 0
      const ano = parseInt(parts[2], 10);
      return new Date(ano, mes, dia);
    }
    return null;
  }

  openPdf(base64: string) {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(blob);
    window.open(fileURL, '_blank');
  }

  getBolsaDetails(bolsaID: string) {
    this.bolsaService.show(bolsaID).subscribe(
      (reponse: any) => {
        if (reponse) {
          this.formRenovacao.patchValue({
            NumeroBI: reponse?.data?.bolseiro?.numeroBI,
            nome: reponse?.data?.bolseiro?.nome,
            estadoBolsaID: reponse?.data?.estadoBolsa,
            estadoDesc: reponse?.data?.estadoBolsaDescricao,
          });
        } else {
          console.error('Bolseiro não encontrado');
        }
      },
      (error: any) => {
        console.error('Erro ao buscar detalhes do bolseiro:', error);
      },
    );
  }

  getMatricula(bolsaInstCursoId: number | undefined) {
    if (!bolsaInstCursoId) return;

    const params = {
      PageNumber: 1,
      PageSize: 10,
      OrderBy: 'ID desc',
      BolsaInstituicaoCursoID: bolsaInstCursoId,
      Estado: EnumEstadoMatricula.NUMBER_2,
    };

    this.matriculaService.list(params).subscribe((result) => {
      if (result) {
        this.matricula = result[0];
        console.log('MAtricula', this.matricula);
        this.formRenovacao.patchValue({
          anoCurricular: this.getLabelAnoCurricular(
            Number(this.matricula?.anoCurricular),
          ),
        });
      }
    });
  }

  loadDropdowns() {
    forkJoin({
      parecerSolicitacao: this.enumService.getAllParecerSolicitacaoEnum(),
    }).subscribe((response) => {
      // Enums
      if (response.parecerSolicitacao?.data) {
        this.parecerOptions = Object.entries(
          response.parecerSolicitacao.data,
        ).map(([key, value]) => ({
          id: Number(key),
          label: value,
        }));

        this.parecerMirempetOptions = this.parecerOptions
          .filter((opt) => opt.id === 1 || opt.id === 2)
          .map((opt) => ({
            ...opt,
            label: opt.id === 2 ? 'Reprovado' : opt.label,
          }));
      }
    });
  }

  private isParecerInvalido(): boolean {
    const v = this.formRenovacao.get('parecerMIREMPET')?.value;
    return [null, 3, undefined].includes(v);
  }
  updateSolicitacao() {
    if (this.solicitacao.estado != 1) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Solicitação já foi validada e não pode ser alterada.',
      });
      return;
    }

    if (this.isParecerInvalido()) {
      this.formRenovacao.get('parecerMIREMPET')?.markAsTouched();
      this.messageService.add({
        severity: 'warn',
        summary: 'Aviso',
        detail: 'Selecione um parecer válido.',
      });
      return;
    }
    const solicitacaoPayload = {
      id: this.solicitacaoID,
      idBolsa: this.bolsaInstituicaoID,
      userId: this.solicitacao?.bolsa?.bolseiroID,
      idAnoLetivoAnterior: 2,
      idAnoLetivoAtivacao: 2,
      estado: this.formRenovacao.get('estadoBolsaID')?.value,
      parecerInstituicao: this.formRenovacao.get('parecerInstituicao')?.value,
      parecerMIREMPET: this.formRenovacao.get('parecerMIREMPET')?.value,
      extraDataJson: '{}',
    };

    this.confirmactionService.confirm({
      message: `Tem certeza que deseja actualizar a solicitação de renovação da bolsa do estudante <strong>${
        this.formRenovacao.get('nome')?.value
      }</strong>?`,
      header: 'Confirmar actualização',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',

      accept: () => {
        this.solicitacaoRenovacaoService
          .updateParecer(solicitacaoPayload)
          .subscribe({
            next: (response: any) => {
              if (response?.retorno?.codigo === 200) {
                this.messageService.add({
                  severity: 'success',
                  summary: 'Sucesso',
                  detail: 'Solicitação actualizada com sucesso!',
                });
                setTimeout(() => {
                  this.getSolicitacaoById(this.solicitacaoID);
                }, 2000);
              } else {
                this.messageService.add({
                  severity: 'error',
                  summary: 'Erro',
                  detail:
                    response?.retorno?.mensagem ||
                    'Erro ao actualizar solicitação.',
                });
              }
            },
            error: (error) => {
              this.messageService.add({
                severity: 'error',
                summary: 'Erro',
                detail:
                  error.retorno?.mensagem || 'Erro ao actualizar solicitação.',
              });
              console.error('Erro ao actualizar solicitação', error);
            },
          });
      },
      reject: () => {
        this.confirmactionService.close();
        this.messageService.add({
          severity: 'info',
          summary: 'Ação Cancelada',
          detail: 'Actualização cancelada.',
        });
      },
    });
  }

  getLabelAnoCurricular(ano?: string | number | null): string {
    const anoNum = Number(ano);

    switch (anoNum) {
      case 1:
        return '1º Ano';
      case 2:
        return '2º Ano';
      case 3:
        return '3º Ano';
      case 4:
        return '4º Ano';
      case 5:
        return '5º Ano';
      case 6:
        return '6º Ano';
      case 7:
        return '7º Ano';
      case 8:
        return '8º Ano';
      case 9:
        return '9º Ano';
      case 10:
        return '10º Ano';
      case 11:
        return '11º Ano';
      case 12:
        return '12º Ano';
      default:
        return 'Ano inválido';
    }
  }

  getEstadoSolicitacao(estado: number): string {
    switch (estado) {
      case 1:
        return 'Pendente';
      case 2:
        return 'Aprovado';
      case 3:
        return 'Rejeitado';
      default:
        return 'Não Informado';
    }
  }

  getSeverity(status: number) {
    switch (status) {
      case 1:
        return 'warn';
      case 2:
        return 'success';
      case 3:
        return 'danger';
      default:
        return 'info';
    }
  }

  getParecerClass(parecer: number | null | undefined): string {
    switch (Number(parecer)) {
      case 1:
        return 'is-approved';
      case 2:
        return 'is-rejected';
      case 3:
        return 'is-pending';
      default:
        return 'is-unknown';
    }
  }

  getParecerIcon(parecer: number | null | undefined): string {
    switch (Number(parecer)) {
      case 1:
        return 'pi-check';
      case 2:
        return 'pi-times';
      case 3:
        return 'pi-clock';
      default:
        return 'pi-minus';
    }
  }

  getParecerLabel(parecer: number | null | undefined): string {
    switch (Number(parecer)) {
      case 1:
        return 'Aprovado';
      case 2:
        return 'Reprovado';
      case 3:
      default:
        return 'Análise';
    }
  }
}
